// extracted by mini-css-extract-plugin
module.exports = {"shell":"Shell_shell___v7aG","shell__header":"Shell_shell__header__0LU1d","shell__footer":"Shell_shell__footer__wSHlJ","shell__content":"Shell_shell__content__N4YHS"};